<div class="number-plate-scan">
  <sc-padding>
    <form class="form" [formGroup]="formGroup">
      <sc-flex [vertical]="true" [stretchContent]="true">
        <mat-form-field appearance="outline">
          <mat-label>{{
            "Camera"
            | translate
            : [
            "tmc-yard.widgets.yard-simulator.number-plate-scanner",
            translationService.language
            ]
            }}</mat-label>
          <mat-select (valueChange)="onCameraSelection($event)">
            <mat-option *ngFor="let camera of cameras" [value]="camera">
              {{ camera.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <sc-string-field formControlName="numberPlateNumber" [label]="
            'Numberplate'
              | translate
                : [
                    'tmc-yard.widgets.yard-simulator.numberplate',
                    translationService.language
                  ]
          " [required]="true">
        </sc-string-field>
      </sc-flex>
    </form>


    <button mat-flat-button class="config-changed-button" (click)="onButtonTrigger()"
      [disabled]="!numberPlateNumber || !cameraSelected">
      {{
      "send"
      | translate
      : [
      "tmc-yard.widgets.yard-simulator.send",
      translationService.language
      ]
      }}
    </button>
  </sc-padding>
</div>
